import { Capability } from '@mono/types/src/mds';

export const capabilitiesByDataTypes = (capabilities: Capability[], dataTypes?: string[] | null) => {
    return dataTypes ? capabilities.filter(({ data_type }) => dataTypes.includes(data_type)) : capabilities;
};
